<script lang="ts">
  import ModalShell from './ModalShell.svelte'

  interface Props {
    title: string
    message: string
    confirmLabel?: string
    cancelLabel?: string
    danger?: boolean
    onConfirm: () => void
    onClose: () => void
  }

  let {
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    danger = false,
    onConfirm,
    onClose,
  }: Props = $props()
</script>

<ModalShell label={title} elevated onClose={onClose}>
  <div class="confirm">
    <h2>{title}</h2>
    <p>{message}</p>
    <div class="actions">
      <button type="button" class="cancel" onclick={onClose}>{cancelLabel}</button>
      <button
        type="button"
        class="ok"
        class:danger
        onclick={() => {
          onConfirm()
          onClose()
        }}
      >{confirmLabel}</button>
    </div>
  </div>
</ModalShell>

<style>
  .confirm {
    padding: var(--space-5);
    width: min(400px, 92vw);
  }
  h2 {
    margin: 0 0 var(--space-3);
    font-size: var(--text-lg);
    font-weight: 600;
    color: var(--text-primary);
  }
  p {
    margin: 0 0 var(--space-5);
    font-size: var(--text-sm);
    line-height: 1.5;
    color: var(--text-secondary);
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--space-2);
  }
  .actions button {
    padding: 8px 16px;
    border-radius: var(--radius-sm);
    font: inherit;
    font-size: var(--text-sm);
    font-weight: 500;
    cursor: pointer;
  }
  .cancel {
    border: 1px solid var(--border-subtle);
    background: var(--bg-page);
    color: var(--text-primary);
  }
  .cancel:hover {
    background: var(--bg-sunken);
  }
  .ok {
    border: 1px solid var(--accent);
    background: var(--accent);
    color: var(--accent-contrast);
  }
  .ok.danger {
    border-color: var(--callout-caution);
    background: var(--callout-caution);
    color: #fff;
  }
  .ok:hover {
    filter: brightness(1.05);
  }
</style>
